export default "__VITE_ASSET__gJ9e8N35__"